import React from 'react';
import { Box, Button, Center, Input, VStack, HStack, Text, Flex } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';
import { MdOutlineArrowUpward } from 'react-icons/md';

const UploadBOQ = () => {
	return (
		<>
			<Box className='mx-auto max-w-4xl rounded-lg bg-blue-900 p-8 text-white shadow-md'>
				<Text className='mb-6 text-center text-xl font-bold'>Upload Bills of Quantities</Text>
				<Flex justify='space-between' align='center'>
					<VStack spacing={4} align='stretch' className='w-1/2'>
						<HStack spacing={4} align='center'>
							<Text className='w-1/3'>Site Location</Text>
							<Input placeholder='Site Location' className='bg-blue-800 text-white placeholder-gray-400' />
						</HStack>
						<HStack spacing={4} align='center'>
							<Text className='w-1/3'>Project Type</Text>
							<Input placeholder='Project Type' className='bg-blue-800 text-white placeholder-gray-400' />
						</HStack>
						<HStack spacing={4} align='center'>
							<Text className='w-1/3'>Date</Text>
							<Input placeholder='Date' type='date' className='bg-blue-800 text-white placeholder-gray-400' />
						</HStack>
						<HStack spacing={4} align='center'>
							<Text className='w-1/3'>Duration</Text>
							<Input placeholder='Duration' className='bg-blue-800 text-white placeholder-gray-400' />
						</HStack>
					</VStack>
					<Box className='ml-4 flex h-full w-1/2 flex-col items-center justify-center '>
						<Text className='pb-5 font-bold text-white'>
							Upload BoQ <Text className=' inline font-light text-gray-400'>or BIM Model</Text>
						</Text>

						<Button className='rounded-lg border-2 border-dashed border-gray-400 bg-blue-800' p={20} colorScheme='whiteAlpha' variant='solid'>
							<Icon as={MdOutlineArrowUpward} w={8} h={8} color='' />
						</Button>
					</Box>
				</Flex>
				<Center>
					<Button colorScheme='blue' className='mt-4 self-center'>
						Submit
					</Button>
				</Center>
			</Box>
		</>
	);
};

export default UploadBOQ;
